import React, {useCallback, useEffect, useState} from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {bindActionCreators} from 'redux';

import Container from '../../../components/ManagerInsights/Container';
import EmptyState from '../../../components/ManagerInsights/EmptyState';
import Header from '../../../components/ManagerInsights/Header';
import SearchBar from '../../../components/ManagerInsights/SearchBar';
import SearchContainer from '../../../components/ManagerInsights/SearchContainer';
import Tabs from '../../../components/ManagerInsights/Tabs';
import TeamPerformanceCard from '../../../components/ManagerInsights/TeamPerformanceCard';
import * as managerInsightsActions from '../../../state/managerInsights/managerInsightsActions';
import {getManagerInsightsByStore} from '../../../state/managerInsights/managerInsightsSelector';
import {formatedDateString} from '../../../utils/managerInsightUtils';

import managerInsightsStyles from '../styles.module.scss';
import styles from './styles.module.scss';

const mapStateToProps = (state, ownProps) => {
  const {insightId, managerId} = ownProps.match.params;
  const managerInsightsByStore = getManagerInsightsByStore(state);

  return {
    insightId,
    managerId,
    users: managerInsightsByStore.get('users').toJS(),
    summary: managerInsightsByStore.get('summary').toJS(),
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(managerInsightsActions, dispatch),
});

const TeamPerformance = ({
  users,
  summary,
  goToManagerInsightsUserDetail,
  goToManagerInsightsHome,
  insightId,
  managerId,
}) => {
  const [keyword, setKeyword] = useState('');
  const [searchMode, setSearchMode] = useState(false);

  useEffect(() => {
    if (!searchMode) {
      setKeyword('');
    }
  }, [searchMode]);

  const activeUsers = users.filter((user) => user.activated);
  const deactiveUsers = users.filter((user) => !user.activated);

  const renderRow = useCallback(
    (user) => (
      <TeamPerformanceCard
        key={user.id}
        fullName={user.name}
        completionPercent={user.percent || 0}
        completionInformation={`${user.completionCount} of ${summary.totalContentCount}`}
        isActive={user.activated}
        joinDate={
          user.activated
            ? formatedDateString(user.activationDate)
            : formatedDateString(user.createdAt)
        }
        onClick={() => {
          if (user.activated) {
            goToManagerInsightsUserDetail({
              managerId,
              insightId,
              uid: user.id,
            });
          }
        }}
      />
    ),
    [
      goToManagerInsightsUserDetail,
      summary.totalContentCount,
      insightId,
      managerId,
    ]
  );

  return (
    <>
      <div className={managerInsightsStyles.view}>
        <div className={managerInsightsStyles.content}>
          <Header
            title='Team Performance'
            onClickBack={() => goToManagerInsightsHome({insightId, managerId})}
          />
          <Container>
            <SearchBar
              value={keyword}
              onChange={setKeyword}
              isModeSearch={searchMode}
              onModeChange={setSearchMode}
            />

            {searchMode ? (
              <SearchContainer
                data={users}
                keyword={keyword}
                type={'user'}
                searchField={'name'}
                rowRender={renderRow}
              />
            ) : (
              <Tabs
                layz
                items={[
                  {
                    id: '1',
                    title: 'Active users',
                    count: activeUsers.length,
                    content: (
                      <>
                        {activeUsers.map(renderRow)}

                        {!activeUsers.length && (
                          <EmptyState
                            type='user'
                            title='User not found'
                            description='There is no user in your team'
                          />
                        )}
                      </>
                    ),
                  },
                  {
                    id: '2',
                    title: 'Not activated',
                    count: deactiveUsers.length,
                    content: (
                      <>
                        {deactiveUsers.map(renderRow)}

                        {!deactiveUsers.length && (
                          <EmptyState
                            type='user'
                            title='User not found'
                            description='There is no user in your team'
                          />
                        )}
                      </>
                    ),
                  },
                ]}
              />
            )}
          </Container>
        </div>
      </div>
    </>
  );
};

TeamPerformance.propTypes = {
  insightId: PropTypes.string.isRequired,
  managerId: PropTypes.string.isRequired,
  goToManagerInsightsUserDetail: PropTypes.func.isRequired,
  goToManagerInsightsHome: PropTypes.func.isRequired,
  summary: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(injectIntl(CSSModules(TeamPerformance, styles, {allowMultiple: true})))
);
